import portsApi from '@/framework/ports/portsApi';

const RemoveSplashPage = {
  remove: () => portsApi.invoke('RemoveSplashPage.remove'),
};

export default RemoveSplashPage;
